import { FC } from "react";
import { getSessionUser } from "common/store/useAuthStore";
import ActionItems from "../components/dashboard/ActionItems";
import ToolsAndTemplates from "../components/dashboard/ToolsAndTemplates";
// import HelpAndResources from "../components/dashboard/HelpAndResources";
import MyCampaigns from "../components/dashboard/MyCampaigns";
export enum MyCampaignsTabs {
  closedCampaigns = "Closed Campaigns",
  drafts = "Drafts",
  activeCampaigns = "Active Campaigns",
}

const DashBoardHomePage: FC = function DashBoardHomePage() {
  const user = getSessionUser();
  const userName = user?.firstName ?? user?.adminFirstName;
  return (
    <div className="mx-2 mt-[61px] min-h-[calc(100vh-280px)] max-w-[868px] lg:mx-auto">
      <p className="font-inter text-[24px] font-semibold leading-[125%] tracking-[-0.5%] text-neutral-900 lg:text-[32px] lg:leading-[40px] lg:tracking-[-1.5%] lg:text-strong-950">
        Welcome, {userName}!
      </p>
      <ActionItems user={user} />
      <ToolsAndTemplates />
      <MyCampaigns />
    </div>
  );
};

export default DashBoardHomePage;
